module.exports = __webpack_public_path__ + "img/planet-green.eddcaf14.svg";